import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import fillMonths from 'teacher-ui-client/utils/student-events/fill-months'

export interface StoriesWrittenStudentResponse {
  stories_written_by_month_events_summary: {
    data: [
      {
        category: 'total_count'
        count: number
      },
    ]
  }
  stories_written_by_month_events: {
    month: string
    count: number
  }[]
}

export interface StoriesWrittenStudentData {
  summary: {
    total_count: number
  }
  events: {
    month: string
    count: number
  }[]
}

export async function storiesWrittenStudent(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StoriesWrittenStudentData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('stories_written_by_month_events', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StoriesWrittenStudentResponse>(url, query)
  if (!data) return null

  const { stories_written_by_month_events_summary: summaryData, stories_written_by_month_events: monthData } = data
  if (monthData.length === 0) return null

  const total_count = summaryData.data.find((d) => d.category === 'total_count')!.count

  return {
    summary: {
      total_count,
    },
    events: fillMonths(monthData, period, {
      count: 0,
    }),
  }
}
